import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import { Box, Typography } from "@mui/material";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, { accordionSummaryClasses, AccordionSummaryProps } from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { CoverageAccordionProps as BaseCoverageAccordionProps } from "../../../../../shared/services/api/fire/types";
import { CoverageItemFields } from "./CoverageItemFields";
interface CustomCoverageAccordionProps {
	group: BaseCoverageAccordionProps["group"]; // Mantém a prop 'group' do tipo original
	disabled: boolean;
	expanded: boolean;
	onChange: (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	"&:not(:last-child)": {
		borderBottom: 0,
	},
	"&::before": {
		display: "none",
	},
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />} {...props} />
))(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	[`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
		transform: "rotate(90deg)",
	},
	[`& .${accordionSummaryClasses.content}`]: {
		marginLeft: theme.spacing(1),
	},
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	borderTop: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, .125)" : "rgba(0, 0, 0, .125)"}`,
}));

const translateType = (label: string) => {
	if (label.startsWith("RESIDENTIAL")) {
		return label.replace("RESIDENTIAL", "RESIDENCIAL");
	}

	if (label.startsWith("COMMERCIAL")) {
		return label.replace("COMMERCIAL", "COMERCIAL");
	}
	return label;
};

// Componente memoizado e com tipagem corrigida.
export const CoverageAccordion = React.memo((props: CustomCoverageAccordionProps) => {
	const { group, disabled, expanded, onChange } = props;
	const translatedGroupLabel = translateType(group.groupLabel);

	return (
		<Accordion disabled={disabled} expanded={expanded} onChange={onChange}>
			<AccordionSummary aria-controls={`panel-${group.groupKey}-content`} id={`panel-${group.groupKey}-header`}>
				<Typography variant="subtitle1">{translatedGroupLabel}</Typography>
			</AccordionSummary>

			<AccordionDetails>
				<Box>
					{group.coverages.map((item) => {
						const namePrefix = `coverage-${item.id}`;
						return (
							<CoverageItemFields
								key={item.id}
								id={item.id}
								namePrefix={namePrefix}
								label={item.label}
								description={item.description}
								minValue={item.limite_min}
								maxValue={item.maxValue}
								factor={item.factor}
								rateIncrease={item.rateIncrease}
								enabled={item.enabled}
								disabled={disabled}
							/>
						);
					})}
				</Box>
			</AccordionDetails>
		</Accordion>
	);
});
